import React, { Component } from "react";
import Fade from "react-reveal/Fade";

import "./Header.css";

export default class Header extends Component {
  render() {
    return (
      <header id="home" className="home">
        <div className={`hero  ${this.props.isNavOpen ? "remove" : ""}`}>
          <div className="hero-body">
            <Fade duration={1000} delay={200}>
              <div className="container">
                <h1 className="title">
                  <div className="home-title-1"> صناعة وتطوير رأس المال</div>{" "}
                  <span className="home-title-2">البشري الحكومي</span>
                </h1>
              </div>
            </Fade>
          </div>
        </div>
      </header>
    );
  }
}
